import React, { useEffect, useRef, useState } from 'react';
import { trustContent } from '../data/mock';
import { getImageUrl } from '../lib/api';
import { Star } from 'lucide-react';

const TrustSection = () => {
  const scrollRef = useRef(null);
  const [isPaused, setIsPaused] = useState(false);

  useEffect(() => {
    const scrollContainer = scrollRef.current;
    if (!scrollContainer) return;

    let animationId;
    let position = 0;

    const animate = () => {
      if (!isPaused) {
        position += 0.5;
        if (position >= scrollContainer.scrollWidth / 2) {
          position = 0;
        }
        scrollContainer.scrollLeft = position;
      }
      animationId = requestAnimationFrame(animate);
    };

    animationId = requestAnimationFrame(animate);

    return () => {
      cancelAnimationFrame(animationId);
    };
  }, [isPaused]);

  // Double the logos for seamless infinite scroll
  const doubledLogos = [...trustContent.logos, ...trustContent.logos];

  return (
    <section className="py-20 lg:py-28 bg-slate-800" id="trust">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <h2 className="text-3xl sm:text-4xl font-bold text-white mb-4">
            {trustContent.title}
          </h2>
          <div className="w-16 h-1 bg-emerald-400 mx-auto" />
        </div>

        {/* Logo carousel */}
        <div
          className="overflow-hidden mb-12"
          onMouseEnter={() => setIsPaused(true)}
          onMouseLeave={() => setIsPaused(false)}
        >
          <div
            ref={scrollRef}
            className="flex items-center space-x-10 overflow-x-hidden py-4"
            style={{ scrollBehavior: 'auto' }}
          >
            {doubledLogos.map((logo, index) => (
              <div
                key={`${logo.id}-${index}`}
                className="flex-shrink-0 bg-white rounded-xl p-4 shadow-lg hover:shadow-xl transition-all duration-300 hover:scale-105"
              >
                <img
                  src={getImageUrl(logo.src)}
                  alt={logo.altText}
                  className="h-20 w-auto object-contain"
                  onError={(e) => {
                    e.target.style.display = 'none';
                    e.target.parentElement.innerHTML = `<div class="text-slate-400 text-xs font-medium text-center px-4 h-20 flex items-center">${logo.altText}</div>`;
                  }}
                />
              </div>
            ))}
          </div>
        </div>

        {/* Proof line */}
        <div className="text-center">
          <div className="inline-flex items-center space-x-2 bg-emerald-500/20 px-6 py-3 rounded-full">
            <Star className="w-5 h-5 text-emerald-400 fill-emerald-400" />
            <span className="text-emerald-100 font-medium">
              {trustContent.proofLine}
            </span>
          </div>
        </div>
      </div>
    </section>
  );
};

export default TrustSection;
